// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {ActivityState, Media, MediaType, PlayerMapping} from "@models";
import {SimUtilityExtendedService, SimUtilityService} from "@services";
import {Translations} from "@translations";

@Component({
	selector: "sim-media-card-video",
	templateUrl: "./media-card-video.component.html",
	styleUrls: ["./media-card-video.component.scss"],
	standalone: false,
})
export class MediaCardVideoComponent {
	T = Translations;
	ActivityState = ActivityState;
	MediaType = MediaType;
	progressFromDisplayedMedia = SimUtilityService.progressFromDisplayedMedia;

	@Input() media: Media;
	@Input() mediaPlayer: PlayerMapping;
	toggleMedia = output<{
		player: PlayerMapping;
		media: Media;
	}>();

	constructor(public simUtilityService: SimUtilityExtendedService) {}

	mediaClicked() {
		if (this.mediaPlayer?.webSocket?.activityState !== ActivityState.Inactive) {
			this.toggleMedia.emit({
				player: this.mediaPlayer,
				media: this.media,
			});
		}
	}
}
